__turbopack_context__.v({
  "featureIcon": "PlasmicTextWithIcon-module__ArtCWG__featureIcon",
  "heading": "PlasmicTextWithIcon-module__ArtCWG__heading",
  "img__h1Ewd": "PlasmicTextWithIcon-module__ArtCWG__img__h1Ewd",
  "text1": "PlasmicTextWithIcon-module__ArtCWG__text1",
  "textContainer": "PlasmicTextWithIcon-module__ArtCWG__textContainer",
  "textWithIcon": "PlasmicTextWithIcon-module__ArtCWG__textWithIcon",
});
